import { useState } from "react";
import StandardHoverBox from "./StandardHoverBox";

const HoverBoxAnchor = ({
  tooltipText,
  children,
}: {
  tooltipText: string;
  children: React.ReactNode;
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && <StandardHoverBox text={tooltipText} />}
    </div>
  );
};

export default HoverBoxAnchor;
